import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';

import { useIsTouchDevice } from '../../hooks/useIsTouchDevice.hook';

import { List } from './List';
import type { ListProps } from './types/list-props.type';

export const DraggableList = <I extends object>({
  getLabel,
  idProp,
  indexProp,
  items,
  setItems,
}: Readonly<ListProps<I>>) => {
  const isTouchDevice = useIsTouchDevice();

  return (
    <DndProvider backend={isTouchDevice ? TouchBackend : HTML5Backend}>
      <List
        getLabel={getLabel}
        idProp={idProp}
        indexProp={indexProp}
        items={items}
        setItems={setItems}
      />
    </DndProvider>
  );
};
